import * as React from "react";

export const IconTrendUp = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_32905_107656)">
      <path d="M6.5 10.5L6.5 3.415L8.295 5.205L9 4.5L6 1.5L3 4.5L3.705 5.205L5.5 3.415L5.5 10.5L6.5 10.5Z" fill="#C34A24"/>
    </g>
    <defs>
      <clipPath id="clip0_32905_107656">
        <rect width="12" height="12" fill="white" transform="translate(12) rotate(90)"/>
      </clipPath>
    </defs>
  </svg>
);
